import type { ILimitationProps } from '../../types/limitation';

import { useCGTemplateListing } from '~/modules/campaign-group-template';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { useLimitation } from './useLimitation';
import { CONFIG_PRICING } from '../../configs';

export interface ILimitCampaignGroupTemplateResult {
  limitRunningCampaignGroupTemplate: number;
  totalRunningCampaignGroupTemplate: number;
  isExistCGTemplate: boolean;
  isEnabled: boolean;
  isReachLimit: boolean;
  isOverLimit: boolean;
  isExistRunning: boolean;
  isUnlimited: boolean;
}

export const useLimitCampaignGroupTemplate = ({
  planKey,
}: ILimitationProps): ILimitCampaignGroupTemplateResult => {
  const { getLimitByPlanKey } = useLimitation();

  const campaignGroupTemplateListing = useCGTemplateListing();
  const planConditions = getLimitByPlanKey(planKey)?.campaign?.templateBundle;

  const isEnabled = planConditions?.enable ?? false;

  const limitRunningCampaignGroupTemplate = isEnabled ? CONFIG_PRICING.NUMBER_OF_LIMIT_INFINITY : 0;
  const totalRunningCampaignGroupTemplate = campaignGroupTemplateListing.data.filter(
    (campaign) => campaign.status === CAMPAIGN_STATUS.RUNNING,
  ).length;
  const isExistCGTemplate = campaignGroupTemplateListing.data.length > 0;

  const isReachLimit = totalRunningCampaignGroupTemplate === limitRunningCampaignGroupTemplate;
  const isOverLimit = totalRunningCampaignGroupTemplate > limitRunningCampaignGroupTemplate;
  const isExistRunning = totalRunningCampaignGroupTemplate > 0;
  const isUnlimited = limitRunningCampaignGroupTemplate === CONFIG_PRICING.NUMBER_OF_LIMIT_INFINITY;

  return {
    limitRunningCampaignGroupTemplate,
    totalRunningCampaignGroupTemplate,
    isExistCGTemplate,
    isReachLimit,
    isOverLimit,
    isEnabled,
    isExistRunning,
    isUnlimited,
  };
};
